import slugify from '@sindresorhus/slugify';

// uses the slugify library that's used by Gatsby itself
// https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/#routing-and-linking
export const formatStoryCategory = (category: string) => {
  // accound for -and- removal done here `packages/rockefellercenter/gatsby-node/on-create-page/article.ts`
  const removeAmpersand = category.replace(' & ', '-');

  return slugify(removeAmpersand, {
    lowercase: true,
  });
};
